import { render, staticRenderFns } from "./ImsOfferingError.vue?vue&type=template&id=d24d054e&"
import script from "./ImsOfferingError.vue?vue&type=script&lang=js&"
export * from "./ImsOfferingError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports